import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatListModule } from '@angular/material/list';
import { MatStepperModule } from '@angular/material/stepper';
import { HelpStepperComponent } from './help-stepper.component';
import { MatIconModule } from '@angular/material/icon';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';
import { SharedPipeModule } from '../pipes/shared-pipe.module';
import { TranslocoModule } from '@ngneat/transloco';

@NgModule({
  imports: [
    CommonModule,
    MatStepperModule,
    MatListModule,
    MatIconModule,
    MatCardModule,
    FlexLayoutModule,
    MatButtonModule,
    SharedPipeModule,
    TranslocoModule
  ],
  declarations: [
    HelpStepperComponent
  ],
  exports: [HelpStepperComponent]
})
export class HelpStepperModule { }
